import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IInactiveParentButton {
  parentId: string;
}

const CustomConfirmButton = ({ parentId }: IInactiveParentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusParent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `parents/${parentId}/inactive`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully inactive parent.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed inactive the parent, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusParent}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const InactiveParentButton = ({ parentId }: IInactiveParentButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Inactive Account`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#f44336" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Inactive The Parent</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to Inactive the parent ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton parentId={parentId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default InactiveParentButton;
